module.exports = __webpack_public_path__ + "static/oceneni-v-ramci-european-customer-centricity-awards-1b810c4f30447cfb060e29bb5f08f519.jpg";